import React from "react"

const defaultContextValue = {
  data: {
    'fullWidth': true,
    'pageTitle': ''
  },
  set: () => {},
}

const { Provider, Consumer } = React.createContext(defaultContextValue)

class LayoutProvider extends React.Component {
  constructor() {
    super()
    this.setData = this.setData.bind(this)
    this.state = {
      ...defaultContextValue,
      set: this.setData,
    }
  }

  setData(newData) {
    setTimeout(() => {
      if (JSON.stringify({
        ...this.state.data,
        ...newData,
      }) !== JSON.stringify(this.state.data)) {
        this.setState({
          data: {
            ...this.state.data,
            ...newData,
          }
        })
      }
    });
  }

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>
  }
}

// function LayoutProvider({data,children}) {
//   const [layoutData,setLayoutData] = useState({
//     ...defaultContextValue.data,
//   })

//   return <Provider value={{
//     data:layoutData,
//     set:(...args)=>{
//       setTimeout(() => {
//         setLayoutData(...args);
//       });
//     },
//   }}>{children}</Provider>
// }

export { Consumer as default, LayoutProvider }